import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getHierarchyLevel,
  getLocationName,
  getPageViewId,
  getParentLocationName,
  getPriceTableData,
} from '../../selectors/selectors';
import PriceTable from './PriceTable';
import { replaceDoubleName } from '../../utils/districtNameUtils';
import DashboardWidget from '../Dashboard/DashboardWidget';

const createHeadline = (hierarchyLevel, location, parentLocation) => {
  if (hierarchyLevel === 'region') {
    return `Quadratmeterpreise für Städte in ${location}`;
  }
  if (hierarchyLevel === 'city') {
    return `Quadratmeterpreise für Stadtteile in ${location}`;
  }
  return `Quadratmeterpreise für weitere Stadtteile in ${parentLocation}`;
};

const PriceTableWidget = ({ hierarchyLevel, pageTitle, priceTableData, location, parentLocation }) => {
  if (!priceTableData || !priceTableData.length) {
    return null;
  }

  const columnHeadLine = hierarchyLevel === 'region' ? 'Stadt' : 'Stadtteil';
  const headline = createHeadline(hierarchyLevel, location, parentLocation);

  return (
    <DashboardWidget
      statuses={['DONE']}
      placeHolder={() => <div />}
      render={() => (
        <PriceTable
          pageTitle={pageTitle}
          headline={headline}
          columnHeadline={columnHeadLine}
          entries={priceTableData.map((p) => ({
            link: p.link,
            locationName: replaceDoubleName(p.name),
            values: p.prices || {},
          }))}
        />
      )}
      widthClasses="one-whole"
    />
  );
};

const mapStateToProps = (state) => ({
  pageTitle: getPageViewId(state),
  priceTableData: getPriceTableData(state),
  hierarchyLevel: getHierarchyLevel(state),
  location: getLocationName(state),
  parentLocation: getParentLocationName(state),
});

PriceTableWidget.propTypes = {
  priceTableData: PropTypes.array.isRequired,
  pageTitle: PropTypes.string.isRequired,
  hierarchyLevel: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  parentLocation: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(PriceTableWidget);
